import Swiper from "swiper";
import {Autoplay, Navigation, Pagination} from "swiper/modules";
Swiper.use([Autoplay, Navigation, Pagination]);

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

export default class MainSlider {
    constructor() {
        this.mainSliderEl = '.js-main-slider';
        this.slider = document.querySelector(this.mainSliderEl);

        if (this.slider) {
            this.init();
        }
    }

    init() {
        const swiper = new Swiper(this.mainSliderEl, {
            loop: true,
            preloadImages: false,
            lazy: true,
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
        });
    }
}
